import { z } from "zod";

export const ADD_BACKUP_METHOD_MODAL = "add-backup";

export const paymentMethodsSearchSchema = z.object({
  modal: z.enum([ADD_BACKUP_METHOD_MODAL]).optional(),
});
